var _g, _rect, _rect2, _rect3, _path, _g2, _rect4, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvvPopUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 71,
    viewBox: "0 0 152 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8243_80424)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.096,
    height: 70.1422,
    rx: 3.36298,
    fill: "#61CCFF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.7764,
    width: 108.096,
    height: 10.5694,
    fill: "#454545"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 33.0957,
    width: 75.4268,
    height: 12.8429,
    fill: "#EFEFEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 33.0957,
    width: 50.9251,
    height: 12.8429,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3265 37.3726L60.172 38.8016H60.2047L61.0544 37.3726H62.0555L60.7759 39.469L62.0841 41.5654H61.0646L60.2047 40.1344H60.172L59.3121 41.5654H58.2967L59.609 39.469L58.3213 37.3726H59.3265ZM63.4476 37.3726L64.2931 38.8016H64.3259L65.1755 37.3726H66.1766L64.8971 39.469L66.2053 41.5654H65.1857L64.3259 40.1344H64.2931L63.4333 41.5654H62.4178L63.7301 39.469L62.4424 37.3726H63.4476ZM67.5688 37.3726L68.4143 38.8016H68.447L69.2967 37.3726H70.2978L69.0182 39.469L70.3264 41.5654H69.3069L68.447 40.1344H68.4143L67.5544 41.5654H66.539L67.8513 39.469L66.5636 37.3726H67.5688Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8243_80424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9061 39.27C75.9061 45.9537 70.6363 51.372 64.1357 51.372C57.635 51.372 52.3652 45.9537 52.3652 39.27C52.3652 32.5862 57.635 27.168 64.1357 27.168C70.6363 27.168 75.9061 32.5862 75.9061 39.27Z",
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9082,
    y: 39.5176,
    width: 75.4268,
    height: 1.97584,
    rx: 0.987918,
    fill: "#F95252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.681 38.1688C126.359 38.1688 126.082 38.1006 125.85 37.9641C125.619 37.8263 125.442 37.6352 125.317 37.3909C125.195 37.1466 125.133 36.8654 125.133 36.5474C125.133 36.2253 125.195 35.9428 125.32 35.6998C125.445 35.4555 125.623 35.2651 125.854 35.1286C126.085 34.9908 126.359 34.9219 126.677 34.9219C126.951 34.9219 127.191 34.9717 127.397 35.0713C127.604 35.171 127.767 35.3109 127.887 35.491C128.007 35.6712 128.073 35.8827 128.085 36.1257H127.262C127.239 35.9687 127.178 35.8425 127.078 35.7469C126.98 35.65 126.851 35.6016 126.691 35.6016C126.556 35.6016 126.438 35.6384 126.337 35.7121C126.237 35.7845 126.16 35.8902 126.104 36.0294C126.048 36.1687 126.02 36.3372 126.02 36.5351C126.02 36.7358 126.047 36.9064 126.102 37.0469C126.158 37.1875 126.236 37.2947 126.337 37.3684C126.438 37.4421 126.556 37.4789 126.691 37.4789C126.791 37.4789 126.88 37.4584 126.959 37.4175C127.04 37.3765 127.106 37.3172 127.158 37.2394C127.211 37.1602 127.246 37.0654 127.262 36.9548H128.085C128.072 37.195 128.006 37.4066 127.889 37.5895C127.773 37.771 127.612 37.9129 127.408 38.0153C127.203 38.1177 126.961 38.1688 126.681 38.1688ZM131.575 34.9628L130.476 38.1074H129.493L128.394 34.9628H129.315L129.968 37.2128H130.001L130.652 34.9628H131.575ZM134.953 34.9628L133.854 38.1074H132.871L131.772 34.9628H132.693L133.346 37.2128H133.379L134.03 34.9628H134.953Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8243_80424",
    x: 0,
    y: 0,
    width: 108.096,
    height: 70.1426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.88788
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8243_80424"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8243_80424",
    x: 50.4435,
    y: 25.7267,
    width: 27.3844,
    height: 28.0475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.480426
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.960852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8243_80424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8243_80424",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvvPopUp);
export default __webpack_public_path__ + "static/media/CvvPopUp.7450da942490a65cd855cc244b0a9fcb.svg";
export { ForwardRef as ReactComponent };